export enum ErrorName {
    INCORRECT_CODE = "Error",
    SIGNIN_EXCEPTION = 'SignInException',
    NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException',
    USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException',
    NO_SESSION = 'NoSession',
}

export enum CardProvider {
    EPS = "EPS",
    TRIBE = "Tribe"
}

export enum CardFramePage {
    SHOW_PIN = 'show-pin',
    ACTIVATE_CARD = 'activate-card'
}